import React, { useRef, useEffect } from 'react';
import useVisible from 'src/util/hooks/use-visible';

interface IVisibilityLoaderProps {
    className?: string;
    onVisibilityChanged: (isVisible: boolean) => void;
}

const VisibilityLoader: React.FC<IVisibilityLoaderProps> = (props) => {
    const loaderRef = useRef();
    const isVisible = useVisible(loaderRef);

    useEffect(() => {
        props.onVisibilityChanged(isVisible);
    }, [isVisible]);

    return (
        <div className={props.className} ref={loaderRef}>
            {props.children}
        </div>
    );
};

export default VisibilityLoader;



// WEBPACK FOOTER //
// ./src/components/common/VisibilityLoader.tsx